import React, { Component } from "react";
import client from "@culturehq/client";
import { ActionButton, Button, Modal, Success, Tooltip, Icon } from "@culturehq/components";

import { useProfile } from "app/context";
import { Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import UserSearch from "components/UserSearch";
import ChqModal from "components/common/ChqModal";

const CheckedInRsvp = ({ user: { name, email } }) => (
  <div className="row chart-row">
    <div className="col-sm-4 col-xs-6">
      {name}
    </div>
    <div className="col-sm-4 col-xs-6">
      {email}
    </div>
    <div className="col-sm-4 hidden-xs">
      Checked In!
    </div>
  </div>
);

const CheckedInUsers = ({ users }) => (
  <div className="chart">
    <div className="row chart-header">
      <div className="col-sm-4 col-xs-6">Name</div>
      <div className="col-sm-4 col-xs-6">Email</div>
      <div className="col-sm-4 hidden-xs" />
    </div>
    {users.map(user => <CheckedInRsvp key={user.id} user={user} />)}
  </div>
);

const getTrigger = onTrigger => (
  <ActionButton onClick={onTrigger}>
    <Icon icon="clipboard" />
    <Trans>Check In Users</Trans>
  </ActionButton>
);

class CheckInModalContext extends Component {
  state = {
    error: null,
    success: false,
    selected: null,
    users: []
  };

  handleClick = async () => {
    const { event: { id: eventId } } = this.props;
    const { selected } = this.state;

    this.setState({ error: null, success: false });

    try {
      await client.checkInEventAttendee({ eventId, userId: selected.id });
      this.setState(({ users }) => ({
        users: [selected].concat(users),
        success: true,
        error: false,
        selected: null
      }));
    } catch (error) {
      this.setState({ error });
    }
  };

  handleClose = () => {
    this.setState({ error: null, success: false, selected: null, users: [] });
  };

  handleUserSelected = selected => {
    this.setState({ error: null, success: false, selected });
  };

  render() {
    const { error, success, selected, users } = this.state;
    const { disabled } = this.props;
    if (disabled) {
      return (
        <span className="user-check">
          <Tooltip tip="You can check in users starting 30 minutes prior to the event">
            <Icon className="ac_icon" icon="clipboard" />
            <span className="user-txt"><Trans>Check in Users</Trans></span>
          </Tooltip>
        </span>
      );
    }
    return (
      <ChqModal onClose={this.handleClose} trigger={getTrigger}>
        <Modal.Heading>
          <Trans>Check In Attendees</Trans>
        </Modal.Heading>
        <Modal.Body>
          <label>
            <Trans>Select a User</Trans>
          </label>
          <UserSearch
            autoFocus
            excludeIds={users.map(user => user.id)}
            onUserSelected={this.handleUserSelected}
          />

          {selected && (
            <Button fillParent primary onClick={this.handleClick}>
              <Trans>Check In {selected.name} ({selected.email})</Trans>
            </Button>
          )}

          {error && <ErrorMessage error={error} />}
          {success && (
            <Success>
              <Trans>User was checked in!</Trans>
            </Success>
          )}

          {users.length > 0 && <CheckedInUsers users={users} />}
        </Modal.Body>
      </ChqModal>
    );
  }
}

const CheckInModal = ({ event, inList = false }) => {
  const { profile } = useProfile();

  if (inList && (event.cancelledAt || !event.isUserHostOrAdmin(profile) || !event.isLive())) {
    return null;
  }

  return (
    <CheckInModalContext
      event={event}
      disabled={event.cancelledAt || !event.isUserHostOrAdmin(profile) || !event.isLive()}
    />
  );
};

export default CheckInModal;
